import { IComponentOptions } from "angular";
import { AnalyticsService, TrackingMetadata } from "@gtmhub/core/analytics";
import { StateService } from "@uirouter/angularjs";

export interface IGridFilteringBarComponentBindings {
  trackingMetadata: Record<string, unknown>;
}

/**
 * Wrapper for grid-related actions (filtering, sorting, columns, etc.)
 *
 * `gh-track-meta` additional metadata for tracking actions
 *
 * @example
 * <grid-filtering-bar gh-track-meta="{ a: 1, b: 2 }">
 *   <grid-filters ...></grid-filters>
 * </grid-filtering-bar>
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GridFilteringBarComponentCtrl extends IGridFilteringBarComponentBindings {}
export class GridFilteringBarComponentCtrl {
  static $inject = ["$state", "AnalyticsService"];

  constructor(private $state: StateService, private analyticsService: AnalyticsService) {}

  track(event: string, meta?: TrackingMetadata): void {
    this.analyticsService.track(event, this.createTrackingMetadata(meta));
  }

  private createTrackingMetadata(meta?: TrackingMetadata): Record<string, unknown> {
    const combinedMeta = meta && this.trackingMetadata ? { ...this.trackingMetadata, ...meta } : meta || this.trackingMetadata || {};
    combinedMeta.screen_name = this.$state.current.name;
    return combinedMeta;
  }
}

export const GridFilteringBarComponent: IComponentOptions = {
  controller: GridFilteringBarComponentCtrl,
  bindings: {
    trackingMetadata: "<ghTrackMeta",
  },
};
